import { change, reset, submit } from 'redux-form'
import { connect, useDispatch } from 'react-redux'
import * as $ from 'jquery';
import { ModalFormWrapper } from '../../../../../../itrust_common/components/others';
import LabOrderForm from './LabOrderForm'
import { orderLoad } from '../../../../../../redux/actions/order/orderActions';
import Alert from '../../../../../../itrust_common/components/Alert';
import { labOrderCreate, labOrderEditCancel, labOrderUpdate } from '../../../../../../redux/actions/order/labOrderActions';

function LabOrderModal(props) {
  const { orderId, resourceType, resourceId } = props
  const dispatch = useDispatch()

  const handleLabOrderEditCancel = () => {
    dispatch(labOrderEditCancel());
    $(`#labOrderForm-${resourceId}-modal`).modal('hide');
  }

  const handleLabOrderSend = async () => {
    await dispatch(change(`labOrderForm-${resourceId}`, 'send_fax', true))
    dispatch(submit(`labOrderForm-${resourceId}`));
  }

  const handleLabOrderSubmit = (data) => {
    data = { ...data, resource_type: resourceType, resource_id: resourceId, orders_order_id: orderId }
    if (data.send_fax && !data.contact_id) {
      Alert.warning('To send Lab Order Secure Fax need to be selected.')
      dispatch(change(`labOrderForm-${resourceId}`, 'send_fax', false))
    }
    else {
      if (data.id !== undefined) {
        dispatch(labOrderUpdate(data))
          .then((response) => handleAfterLabOrderSubmit(response))
          .catch(() => dispatch(change(`labOrderForm-${resourceId}`, 'send_fax', false)))
      }
      else {
        dispatch(labOrderCreate(data))
          .then((response) => handleAfterLabOrderSubmit(response))
          .catch(() => dispatch(change(`labOrderForm-${resourceId}`, 'send_fax', false)))
      }
    }
  }

  const handleAfterLabOrderSubmit = (response, data) => {
    dispatch(orderLoad(orderId, { include: '*' }))
    let url = response.value.data.lab_order.pdf_attributes.file.url
    window.open(url, '_blank');
    data.send_fax && handleLabOrderFormClose()
  }

  const handleLabOrderFormClose = () => {
    $(`#labOrderForm-${resourceId}-modal`).modal('hide');
    dispatch(reset(`labOrderForm-${resourceId}`))
    dispatch(labOrderEditCancel());
  }

  return (
    <div className="inner-modal">
      <ModalFormWrapper
        formName={`labOrderForm-${resourceId}`}
        formTitle="Lab Order"
        modalSize="modal-md"
        modalContentClasses="border-0 rounded shadow-lg"
        label='Save and Create'
        button2Submit={() => handleLabOrderSend()}
        handleEditCancel={handleLabOrderEditCancel}
      >
        <LabOrderForm
          resourceId={resourceId}
          resourceType={resourceType}
          onSubmit={handleLabOrderSubmit}
          form={`labOrderForm-${resourceId}`}
        />
      </ModalFormWrapper>
    </div>
  )
}

const mapStateToProps = state => {
  const { labOrder, order: { order } } = state;
  return {
    saving: labOrder.saving,
    orderId: order.id
  }
}

export default connect(mapStateToProps)(LabOrderModal);